var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{staticClass:"position-fixed fixed-bottom m-0 rounded-0",staticStyle:{"z-index":"2000"},attrs:{"variant":"primary","dismissible":""},model:{value:(_vm.showTop),callback:function ($$v) {_vm.showTop=$$v},expression:"showTop"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('notification.cookie', {uri_cookies: '#/cookies'}))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }